import React, { useRef, useState } from "react";
import "./about.css";
import Intro from "../../../src/assets/intro_video.mp4";

const IntroVideo = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (!videoRef.current) return;

    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="intro-video-container">
      <div className="video-wrapper" onClick={togglePlay}>
        <video
          ref={videoRef}
          src={Intro}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}

          style={{
            width: "100%",
            borderRadius: "1.5rem",
          }}
        />
        {!isPlaying && <button className="center-play-btn">
          {isPlaying ? "⏸" : "▶"}
        </button>}

      </div>
    </div>
  );
};

export default IntroVideo;